import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Platforms() {
  return (
    <Container className="mt-5">
      <h1>Platforms</h1>
      <Row>
        <Col md={3}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Shopify</Card.Title>
              <Card.Text>Manage your Shopify inventory.</Card.Text>
              <Button as={Link} to="/platforms/shopify" variant="primary">Go to Shopify</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>eBay</Card.Title>
              <Card.Text>Manage your eBay inventory.</Card.Text>
              <Button as={Link} to="/platforms/ebay" variant="primary">Go to eBay</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Mercari</Card.Title>
              <Card.Text>Coming soon!</Card.Text>
              <Button as={Link} to="/platforms/mercari" variant="primary">Go to Mercari</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Walmart</Card.Title>
              <Card.Text>Manage your Walmart inventory.</Card.Text>
              <Button as={Link} to="/platforms/walmart" variant="primary">Go to Walmart</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Platforms;